import { DEFAULT_KAER_TEAM_ID } from "@/helper/systemIds";
import type { CrudColumnDef } from "@/components/tables/crudColumnDef";
import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

// preset values for creating a row
export const buildCreatePresetValues = (
  customCreatePresetValues: Record<string, any> | undefined
): Record<string, any> =>
  customCreatePresetValues ?? { team: DEFAULT_KAER_TEAM_ID };

// preset values for editing a row 
export const buildEditPresetValues = (
  rowData: Record<string, any>,
  columns: CrudColumnDef[],
  entityAdapter?: EntityAdapter
): Record<string, any> => {
  const presetValues: Record<string, any> = { ...rowData };

  columns.forEach((column) => {
    if (column.childEntityName && column.id) {
      presetValues[column.id] = presetValues[column.childEntityName][column.id]; 
    }
  });

  return entityAdapter?.adjustEditPresetValues
    ? entityAdapter.adjustEditPresetValues(presetValues)
    : presetValues;
};
